const startsWith = (baseString, searchedString) => baseString.indexOf(searchedString, 0) === 0;
export { startsWith as default };
